// extracted by mini-css-extract-plugin
export default {"title":"styles_title__7Grj0","delegations":"styles_delegations__xWMR3","delegation":"styles_delegation__dx-FH","link":"styles_link__pJM7J","separator":"styles_separator__56NjC"};